const bewertungsListen = document.querySelectorAll('.ce_rsce_bewertungen .reviews[data-fn-sichtbar]');

// Bei 17 Bewertungen ist die Seite sonst endlos. Eingeklappt werden die
// ersten drei gezeigt, der Rest auf Klick.
bewertungsListen.forEach((liste) => {
    const leiste = liste.parentNode.querySelector('.reviews-toggle');

    if (!leiste) {
        return;
    }

    const knopf = leiste.querySelector('button');
    const sichtbar = parseInt(liste.dataset.fnSichtbar, 10) || 3;

    liste.querySelectorAll('.review').forEach((review, i) => {
        if (i >= sichtbar) {
            review.classList.add('ist-versteckt');
        }
    });

    liste.classList.add('is-collapsed');
    leiste.hidden = false;

    knopf.addEventListener('click', () => {
        const offen = !liste.classList.toggle('is-collapsed');
        knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
        knopf.textContent = offen ? knopf.dataset.auf : knopf.dataset.zu;

        if (!offen) {
            liste.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });
});
